import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AppTranslateService {

  public static AVAILABLE_LOCALES = ['es', 'en'];
  public static DEFAULT_LOCALE = 'es';

  constructor(
    private translate: TranslateService
  ) { }

  setTranslateLanguageFromBrowser(): void {
    this.translate.setDefaultLang(AppTranslateService.DEFAULT_LOCALE);
    const browserLanguages = navigator.languages;
    for (const browserLanguage of browserLanguages) {
      const browserLanguageSplit = browserLanguage.split('-')[0];
      if (AppTranslateService.AVAILABLE_LOCALES.includes(browserLanguageSplit)) {
        this.translate.use(browserLanguageSplit);
        return;
      }
    }
  }

}
